export * from './Svg';
//# sourceMappingURL=index.js.map